// extracted by mini-css-extract-plugin
export default {"filter":"MultiSelectFilter_filter__OSCap"};